<!-- <button *ngIf="!visible" (click)="getDetails()">Get Details</button> -->
<ng-container id="üstMenü">
  <div *ngIf="visible" style="font-size: 18px">
    <b
      ><ng-container *ngFor="let item of inventionDetailData; let i = index">
        Buluş Adı:{{ item.inventionName }}
      </ng-container></b
    >
  </div>
  <div *ngIf="visible">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      Dosya No:{{ item.documentNumber }}
    </ng-container>
  </div>
  <div *ngIf="visible">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      Dosya Durumu:{{ status }}
    </ng-container>
  </div>
</ng-container>
<ng-container style="margin-left: -19%">
  <button class="btn" (click)="navigate()">Üst Menüye Git</button>
</ng-container>

<p></p>

<div *ngIf="visible">
  <ng-container id="yanMenü">
    <ul>
      <li>
        <a class="nav-item nav-link" (click)="summary()"> Buluş Bilgileri </a>
      </li>
      <li><a class="nav-item nav-link" (click)="documents()">Dosyalar</a></li>
      <li>
        <a class="nav-item nav-link" (click)="timeLimits()">İşlem Kayıtları</a>
      </li>
      <li *ngIf="isAccepted">
        <a class="nav-item nav-link" (click)="decision()">Alınan Kararlar</a>
      </li>
      <li *ngIf="!isAccepted">
        <a class="nav-item nav-link" (click)="recordTheInvention()">
          Buluş Kabulü
        </a>
      </li>
      <li>
        <a class="nav-item nav-link" (click)="mailCenter()">Mail Gönderme</a>
      </li>
      <li *ngIf="agreement">
        <a class="nav-item nav-link" (click)="inventorAgreements()"
          >Buluş Sahibi Sözleşmesi</a
        >
      </li>
      <li *ngIf="isPatentEnterenceAccepted">
        <a class="nav-item nav-link" (click)="patentRecords()"
          >Patent Kayıtları</a
        >
      </li>
      <li>
        <a class="nav-item nav-link" (click)="forms()">Formlar</a>
      </li>
      <li *ngIf="isAccepted">
        <a class="nav-item nav-link" (click)="addNote()">Notlar</a>
      </li>
    </ul>
  </ng-container>
</div>

<div *ngIf="visibleNotes" id="data">
  <textarea
    type="textarea"
    style="width: 95%; min-height: 100px"
    rows="10"
    cols="42"
    [(ngModel)]="notes"
    (ngModelChange)="notes = $event.toLowerCase()"
    class="form-check-input"
    type="text"
  >
  </textarea>
  <button
    class="btn"
    (click)="recordNote()"
    style="
      margin-left: auto;
      margin-right: 20%;
      font-size: 18px;
      display: block;
      background-color: #28384f;
    "
  >
    Notu Kaydet
  </button>
</div>
<h2 id="data">{{ errorText2 }}</h2>
<div
  *ngIf="visibleSummary"
  id="data"
  style="word-wrap: break-word"
  style="margin-left: 20%"
>
  <button
    class="btn btn-dark"
    (click)="recordTheInvention()"
    style="
      margin-left: 0%;

      font-size: 18px;
      display: block;
    "
  >
    Buluş Bilgilerini Güncelle
  </button>
  <ng-container class="row">
    <strong> <label>Buluş Bilgileri:</label></strong>
    <p></p>
    <div style="margin-left: -19%">
      <table>
        <th>Dosya No</th>
        <th>Buluş Adı</th>
        <th>Buluş Tarihi</th>
        <th>Buluşun Durumu</th>
        <th>Buluşun Vekili</th>
        <tr>
          <td>{{ documentNumber }}</td>
          <td>{{ inventionName }}</td>
          <td>{{ inventionDate | date: "dd/MM/yyyy" }}</td>
          <td>{{ status }}</td>
          <td>
            <ng-container *ngFor="let item of attorneyData; let i = index">
              <td>{{ item.name }}</td>
            </ng-container>
          </td>
        </tr>
      </table>
    </div>

    <p>Not:{{ notes }}</p>
    <hr />
    <strong><label>Başvuru Sahibi Bilgileri:</label></strong>
    <p></p>
    <div style="margin-left: -19%">
      <table>
        <th>#</th>
        <th>Adı</th>
        <th>Kurum No.</th>
        <th>Adres</th>
        <th>Yüzdelik pay</th>
        <tr *ngFor="let item of companyData; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.identity }}</td>
          <td>{{ item.adress }}</td>
          <td>{{ item.share }}</td>
        </tr>
      </table>
    </div>
    <hr />
    <strong> <label>Buluş Sahibi Bilgileri:</label></strong>

    <p></p>
    <div style="margin-left: -19%">
      <table>
        <th>#</th>
        <th>Adı</th>
        <th>Adresi</th>
        <th>Çalıştığı Başvuru Sahibi</th>
        <th>e-posta</th>
        <th>Kimlik No.</th>
        <th>Payı (%)</th>
        <tr *ngFor="let item of inventorData; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.adress }}</td>
          <td>{{ item.inventorsCompany }}</td>
          <td>{{ item.mail }}</td>
          <td>{{ item.identity }}</td>
          <td>{{ item.share }}</td>
        </tr>
      </table>
    </div>
    <hr />
    <ng-container *ngIf="checkCountry()">
      <strong> <label>Ülke Bilgileri:</label></strong>
      <p></p>
      <div style="margin-left: -19%">
        <table>
          <th>Ülke</th>
          <th>Giriş Tarihi</th>
          <th>Tescil Tarihi</th>

          <th>Tür</th>
          <th>Son Durum</th>
          <tr *ngFor="let item of patentInfo; let i = index">
            <td>{{ item.patentCountry }}</td>
            <td>{{ item.patentStatus[0].status[1] | date: "dd/MM/yyyy" }}</td>

            <td>
              <ng-container>
                <!-- {{
                    item.patentStatus[
                      item.patentStatus.length - 1
                    ].status[0].includes("Tescil")
                      ? item.patentStatus[item.patentStatus.length - 1]
                          .status[0]
                      : null
                  }} -->
                {{
                  (item.patentStatus[
                    item.patentStatus.length - 1
                  ].status[0].includes("Tescil") || item.patentStatus[
                  item.patentStatus.length - 1
                ].status[0].includes("tescil"))
                    ? (item.patentStatus[item.patentStatus.length - 1].status[1]
                      | date: "dd/MM/yyyy")
                    : (null | date: "dd/MM/yyyy")
                }}
              </ng-container>
            </td>

            <td>
              {{ item.patentStatus[item.patentStatus.length - 1].type }}
            </td>
            <td>
              {{
                item.patentStatus[item.patentStatus.length - 1] > 0
                  ? item.patentStatus[item.patentStatus.length - 1].status
                  : item.patentStatus[item.patentStatus.length - 1].status
              }}
            </td>
          </tr>
        </table>
      </div>
    </ng-container>
    <hr />
    <ng-container *ngIf="checkDocument()">
      <strong> <label>Dosya Bilgileri:</label></strong>
      <p></p>

      <div style="margin-left: -19%">
        <table>
          Buluş Dosyaları:
          <th>#</th>
          <th>Dosya Adı</th>
          <th>Dosya Türü</th>
          <th>Dosya Linki</th>
          <tr *ngFor="let item of docLink; let i = index">
            <td></td>
            <td>{{ i + 1 }}</td>
            <td>{{ item.docName }}</td>
            <td>{{ item.type }}</td>
            <td><a href="{{ item.link }}" target="_blank">Link</a></td>
          </tr>
        </table>
        <p></p>

        <table>
          Ülke Dosyaları:
          <th>#</th>
          <th>Ülke</th>
          <th>Dosya Adı</th>
          <th>Dosya Türü</th>
          <th>Dosya Linki</th>
          <tr *ngFor="let item of patentInfo; let i = index">
            <ng-container *ngFor="let subitem of item.countryDocLink">
              <td></td>

              <td>{{ i + 1 }}</td>
              <td>{{ item.patentCountry }}</td>
              <td>{{ subitem.docName }}</td>
              <td>{{ subitem.type }}</td>
              <td><a href="{{ subitem.link }}" target="_blank">Link</a></td>
              <!-- <td></td>
                <td>{{ i + 1 }}</td>
                <td>{{ subitem.docName }}</td>
                <td>{{ subitem.type }}</td>
                <td><a href="{{ subitem.link }}" target="_blank">Link</a></td> -->
            </ng-container>
          </tr>
        </table>
      </div>
    </ng-container>
  </ng-container>
  <hr />
</div>
<div *ngIf="visibleForms" style="margin-left: 21%">
  <div>
    <button
      (click)="ulkeCikisFormu()"
      class="btn btn-danger"
      style="background-color: #d70040; float: left"
    >
      Ülke Çıkış Karar Formu
    </button>
    <button
      (click)="hakTalebiFormu()"
      class="btn btn-danger"
      style="background-color: #28384f; float: left ;margin-left: 5%;"
    >
      Hak Talebi Karar Formu
    </button>
    <button
      (click)="bulusBildirimFormu()"
      class="btn btn-danger"
      style="background-color: #d70040; float: left;margin-left: 5%"
    >
      Buluş Bildirimi Formu
    </button>
  </div>
  <br>
  <div id="ülkeÇıkış" #ülkeÇıkış *ngIf="visibleUlkeCikisFormu">
    <p></p>
    <h1>Ülke Çıkış Karar Formu</h1>
    <p></p>
    <table style="border: 1px solid black; margin-left: -0%">
      <tr>
        <td style="width: 20%">
          <strong>Buluş Başlığı</strong>
          <p>
            <em style="font: size 10px">
              (Marka niteliğindeki terimleri içerecek şekilde olmamalıdır.)</em
            >
          </p>
        </td>
        <td>
          <textarea
            type="text"
            style="width: 95%"
            rows="1"
            cols="42"
            [(ngModel)]="inventionName"
            (ngModelChange)="inventionName = $event.toLowerCase()"
          >
          </textarea>
        </td>
      </tr>
      <tr>
        <td style="width: 20%">
          <strong>Patent Başvuru Numarası</strong>
          <p>
            <em style="font: size 10px"> </em>
          </p>
        </td>
        <td>
          <textarea
            type="text"
            style="width: 95%"
            rows="1"
            cols="42"
            [(ngModel)]="formPatentNumber"
            (ngModelChange)="formPatentNumber = $event.toLowerCase()"
          >
          </textarea>
        </td>
      </tr>
      <tr>
        <td style="width: 20%">
          <strong>İlk Patent Başvurusu Tarihi</strong>
        </td>
        <td style="text-align: left">
          <input
            type="date"
            placeholder="ilk başvuru tarihi"
            style="width: 20%; margin-left: 3%"
            [(ngModel)]="formPatentDate"
          />
        </td>
      </tr>
      <tr>
        <td style="width: 20%">
          <strong>Son Kararın Verilmesi Gereken Tarih</strong>
        </td>
        <td style="text-align: left">
          <input
            type="date"
            placeholder="son karar tarihi"
            style="width: 20%; margin-left: 3%"
          />
        </td>
      </tr>
    </table>

    <h3 style="color: #d70040">Önemli Açıklama:</h3>
    <p style="margin-right: 8%">
      Yurtdışı patent süreç maliyetleri yüksek olmasından dolayı (fiyatlar
      ülkeye ve başvuru sistemine göre farklılık göstermekle birlikte 1 ülkede
      20 yıllık patent koruması maliyeti ortalama 10.000$ olarak düşünülebilir.)
      Ülke listesi belirlenirken buluşa konu olan ürünün o ülkedeki satış
      miktarı, ülkedeki rakip firmaların faal olup olmadığı ve en önemlisi bir
      buluşumuza yapılacak ihlalin o ülkede tespit yeteneğimizin olup olmadığı
      değerlendirilmelidir. Seçilen ülkede ihlali tespit edebilecek ekibimiz
      veya kaynağımız olmaması durumunda o ülkedeki korumanın firmamıza bir
      avantajı olmayacaktır. Patent ihlal davaları her ülkede ayrı ayrı açılmalı
      ve her ülkedeki maliyet değişiklik göstermekle birlikte ortalama 30.000$
      mertebesinde olabilmektedir. Bir ürüne ilişkin bir ülkede patent alınması
      o ürünü üretme serbestliğimiz ile bir ilişkisi bulunmamaktadır. Patent
      almadan da bir ürünü üretebilir, satışını yapabiliriz. Patent başvurumuz
      olması o ürünü üretme serbestliği açısından firmamıza ek avantaj
      sağlamayacaktır. Patent alınmasının tek hedefi rakip firmaların patent
      dokümanında belirtilmiş alandaki ürünün koruma olduğu ülkelerde
      üretim/satış yapmasını engellemektir. Bir nevi patentte belirtilen alanı
      koruma yapılan ülkelerde tekelimize almaktır.
    </p>
    <h3 style="margin-left: 0%; color: #28384f">Ülke Çıkış Kararı:</h3>
    <table style="border: 1px solid black; width: 97%; margin-left: -0%">
      <tr>
        <td style="width: 80%"></td>
        <td style="width: 10%; border: 1px solid black">Evet</td>
        <td style="width: 10%; border: 1px solid black">Hayır</td>
      </tr>
      <tr>
        <td style="width: 80%">
          <strong>Ülke çıkışı yapılacak mıdır?</strong>
        </td>
        <td style="width: 10%">
          <input
            type="radio"
            name="radio1"
            style="
              height: 20px;
              width: 20px;
              margin-left: 35%;
              margin-top: 5%;
              border: 1px solid black;
            "
          />
        </td>
        <td style="width: 10%">
          <input
            type="radio"
            name="radio1"
            style="
              height: 20px;
              width: 20px;
              margin-left: 35%;
              margin-top: 5%;
              border: 1px solid black;
            "
          />
        </td>
      </tr>
    </table>

    <br />
    <h3 style="margin-left: 0%; color: #28384f">
      Ülke Çıkışı Yapılması İstenen Ülkeler
    </h3>
    <table style="border: 1px solid black; width: 97%; margin-left: 0%">
      <tr>
        <td>
          <textarea type="text" style="width: 95%" rows="1" cols="42">
          </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="border: 1px solid black; width: 97%; margin-left: -0%">
      <tr style="background-color: #28384f">
        <th style="color: #f8f9fb">Onaylayan İsim-Ünvan</th>
        <th style="color: #f8f9fb">Tarih-İmza</th>
      </tr>

      <tr style="background-color: white">
        <td style="border: 1px solid black; height: 150px"></td>
        <td style="border: 1px solid black; height: 150px"></td>
      </tr>
    </table>
    <p></p>
  </div>
  <button
    *ngIf="visibleUlkeCikisFormu"
    ngxPrint
    printSectionId="ülkeÇıkış"
    class="btn"
    (click)="onToggle()"
    style="
      margin-left: auto;
      margin-right: 10%;
      font-size: 18px;
      display: block;
      background-color: #0275d8;
    "
  >
    PDF çıktısı al
  </button>
  <div
    *ngIf="visibleHakTalebiFormu"
    id="text"
    style="margin-left: 0%; box-sizing: border-box"
  >
    <div id="haktalep" #haktalep>
      <p></p>
      <h1>Buluş Hak Talebi Karar Formu</h1>
      <p></p>
      <table style="border: 1px solid black; width: 100%; margin-left: 0%">
        <tr>
          <td style="width: 20%">
            <strong>Buluş Başlığı</strong>
            <p>
              <em style="font: size 10px">
                (Marka niteliğindeki terimleri içerecek şekilde
                olmamalıdır.)</em
              >
            </p>
          </td>
          <td>
            <textarea
              type="text"
              style="width: 95%"
              rows="1"
              cols="42"
              [(ngModel)]="inventionName"
              (ngModelChange)="inventionName = $event.toLowerCase()"
            >
            </textarea>
          </td>
        </tr>
        <tr>
          <td style="width: 20%"><strong>Buluş Bildirim Tarihi</strong></td>
          <td style="width: 80%; text-align: left">
            <input
              type="date"
              placeholder="Buluş bildirim tarihi"
              style="width: 20%; margin-left: 3%"
              [(ngModel)]="inventionDate"
            />
          </td>
        </tr>
        <tr>
          <td style="width: 20%">
            <strong
              >Başka bir şahıs, firma veya üniversite ile işbirliği var
              mıdır?</strong
            ><em>(Evet ise detaylandırın)</em>
          </td>
          <td>
            <textarea type="text" style="width: 95%" rows="5" cols="42">
            </textarea>
          </td>
        </tr>
      </table>

      <p></p>

      <p></p>
      <div style="margin-left: 2%">
        <h2 style="color: #28384f; margin-left: -1%">
          Aşağıda belirtilen tabloda A,B ve C durumlarından talep edilen kutu
          işaretlenmelidir.
        </h2>
        <p></p>
        <p style="margin-left: -1%; font-size: 18px; color: #28384f">
          Seçeneklerin detaylı açıklaması:
        </p>

        <span style="color: #28384f">A Seçeneği:</span>
        Kanuna göre patent başvurusu yapılması ve hak Sahibliği Başvuru Sahibi
        tarafından alınması durumunda Buluş sahiplerine “Çalışan Buluşlarına,
        Yükseköğretim Kurumlarında Gerçekleştirilen Buluşlara ve Kamu Destekli
        Projelerde Ortaya Çıkan Buluşlara Dair Yönetmelik” ’te belirtilen
        esaslar çerçevesinde ödeme yapılır.
        <p></p>
        <span style="color: #28384f">B Seçeneği:</span>
        Patent başvurusu yapılmadan buluşun gizli tutulmasına karar verilirse A
        maddesindeki durumların tamamı yine geçerli olacaktır. Üretimde olan
        ürünlerde elde edilen gelirden pay verilmesi süresinin sınırı kanunda
        belirtilmemiştir.
        <p></p>
        <span style="color: #28384f">C Seçeneği:</span>
        Söz konusu buluşa ilişkin Başvuru Sahibin bir hak talebi olmayacağına
        karar verilirse buluş serbest kalır ve Buluş Sahibi tarafından
        kullanılabilir veya Buluş Sahibi tarafından 3.kişilere satılabilir.
      </div>

      <p></p>

      <h3 style="margin-left: 1%">Lütfen ilgili seçeneği işaretleyiniz:</h3>

      <table style="border: 1px solid black; width: 100%; margin-left: 0%">
        <tr style="width: 100%">
          <td style="border: 1px solid black; width: 90%; text-align: left">
            <strong
              >A. Patent başvurusu yapılsın ve hak Sahibi
              {{ CompanyDataName | json }} olsun.</strong
            >
          </td>

          <td style="border: 1px solid black; width: 10%">
            <input
              type="radio"
              name="radio1"
              style="
                height: 20px;
                width: 20px;
                margin-left: 35%;
                margin-top: 5%;
              "
            />
          </td>
        </tr>
        <tr style="width: 100%">
          <td style="border: 1px solid black; width: 90%; text-align: left">
            <strong
              >B. Buluş gizli tutulsun ve hak Sahibi
              {{ CompanyDataName | json }} olsun.</strong
            >
          </td>

          <td style="border: 1px solid black; width: 10%">
            <input
              type="radio"
              name="radio1"
              style="
                height: 20px;
                width: 20px;
                margin-left: 35%;
                margin-top: 5%;
              "
            />
          </td>
        </tr>
        <tr style="width: 100%">
          <td style="border: 1px solid black; width: 90%; text-align: left">
            <strong
              >C. Buluş serbest buluş olsun ve hak sahibi Buluşçular
              olsun.</strong
            >
          </td>

          <td style="border: 1px solid black; width: 10%">
            <input
              type="radio"
              name="radio1"
              style="
                height: 20px;
                width: 20px;
                margin-left: 35%;
                margin-top: 5%;
              "
            />
          </td>
        </tr>
      </table>

      <p></p>
      <table style="border: 1px solid black; width: 100%; margin-left: 0%">
        <tr style="background-color: #28384f; color: white">
          <td style="border: 1px solid black">Onaylayan İsim-Ünvan</td>
          <td style="border: 1px solid black">Tarih-İmza</td>
        </tr>

        <tr style="background-color: white">
          <td style="border: 1px solid black; height: 150px"></td>
          <td style="border: 1px solid black; height: 150px"></td>
        </tr>
      </table>
      <p></p>
    </div>
    <button
      *ngIf="visibleHakTalebiFormu"
      ngxPrint
      printSectionId="haktalep"
      class="btn"
      (click)="onToggle()"
      style="
        margin-left: auto;
        margin-right: 10%;
        font-size: 18px;
        display: block;
        background-color: #0275d8;
      "
    >
      PDF çıktısı al
    </button>
  </div>
  <div *ngIf="visibleBulusBildirimFormu" id="text" style="margin-left: 0%; box-sizing: border-box" >
    <div id="bbf" #bbf>
      <p></p>
    <p></p>
    <h1>Buluş Bildirim Formu</h1>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 20%">
          <strong>Buluş Başlığı</strong>
          <p>
            <em>
              (Marka niteliğindeki terimleri içerecek şekilde olmamalıdır.)</em
            >
          </p>
        </td>
        <td style="width: 80%">
          <textarea type="text" rows="1" cols="42"> </textarea>
        </td>
      </tr>
      <tr>
        <td style="width: 20%"><strong>Buluş Bildirim Tarihi</strong></td>
        <td style="text-align: left; width: 80%">
          <input
            type="date"
            placeholder="Buluş bildirim tarihi"
            style="width: 20%"
          />
        </td>
      </tr>
    </table>

    <p></p>

    <p></p>

    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 60%">
          <strong
            >Buluş Sahibi Telefon /TC Kimlik Numarası/Başvuru Sahibi
            e-posta/şahsi e-posta/Adres :</strong
          >
        </td>
        <td style="width: 10%">
          <strong>KATKI ORANI (%) </strong><em>(Toplam %100 olmalıdır.)</em>
        </td>
        <td style="width: 30%"><strong>Buluş Sahibi İMZA</strong></td>
      </tr>

      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td></td>
      </tr>
    </table>

    <p></p>
    <h1 style="text-align: center">
      Buluş Sahibi sayısı toplam <input type="text" style="width: 15%" /> (
      <input type="text" style="width: 5%" /> ) adettir.
    </h1>

    <p></p>
    <h3 style="text-align: center">
      <span style="color: #28384f"
        >Başvuru Sahibi Topluluk dışından Buluş Sahibi var ise aşağıdaki tabloda
        belirtiniz</span
      >
    </h3>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 50%">
          <strong
            >Buluş Sahibi Telefon /Kurum e-posta/şahsi e-posta/Adres :</strong
          >
        </td>
        <td>
          <strong>Çalıştığı Başvuru Sahibi/Kurum </strong>
        </td>
        <td><strong>TC Kimlik Numarası</strong></td>
      </tr>

      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td><textarea rows="1" cols="15"></textarea></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td><textarea rows="1" cols="15"></textarea></td>
      </tr>
      <tr>
        <td>
          <textarea rows="1" cols="40"> </textarea>
        </td>
        <td>
          <textarea rows="1" cols="15"></textarea>
        </td>
        <td><textarea rows="1" cols="15"></textarea></td>
      </tr>
    </table>
    <p></p>

    <div style="margin-left: 2%">
      <strong style="color: red">
        Söz konusu formda sorulan tüm soruların ayrıntılı bir biçimde
        açıklanması halinde;
      </strong>

      <li>
        Ulusal ve uluslararası veri tabanlarında yapılacak olan ön araştırma
        işlemi en doğru şekilde yapılabilir.
      </li>
      <li>
        Buluşun açıklandığı tarifname ve koruma kapsamını belirleyen istemler en
        iyi şekilde ifade edilebilir.
      </li>
      <li>
        Tarifname ve istemlerin en doğru şekilde ifade edilmesi sonucunda ise
        hakkın ileri sürülmesine ilişkin durumlarda yada üçüncü kişilerce
        gerçekleşecek olası hak ihlallerinde buluşun savunulması kolaylaşır.
      </li>
    </div>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr style="border: 1px solid black">
        <td style="width: 30%">
          <strong>Anahtar Kelimeler:</strong>
          <p>
            <em>
              (Buluşu en iyi şekilde ifade ettiğini düşündüğünüz kelime ve
              kelime öbeklerini yazınız.)(Tercihen İngilizce terimler
              kullanılmalıdır.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr style="border: 1px solid black">
        <td style="width: 30%">
          <strong>Buluşun ilgili olduğu teknik alan: </strong>
          <p>
            <em>
              (Buluşun ne ile ilgili olduğunu yani hangi ürünle, hangi yöntemle
              ya da hangi sanayi kolu ile ilgili olduğunu belirtiniz.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 30%">
          <strong>Önceki Teknik:</strong>
          <p>
            <em>
              (Buluş konusunun ilgili olduğu teknik alanda var olan uygulamalar,
              benzer niteliğe Sahib ürünler, biliniyor ise patentler ve diğer
              yayınları belirtiniz.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 30%">
          <strong>Önceki Teknikte Saptanan Teknik Sorunlar: </strong>
          <p>
            <em>
              (İlgili buluştan önceki uygulamalarda karşılaşılan sorunları
              açıklayınız.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 30%">
          <strong>Buluş ile elde edilen avantajlar:</strong>
          <p>
            <em>
              (Önceki teknikte yer alan uygulamalarda karşılaşılan sorunlara
              karşı buluşun sağladığı avantajları belirtiniz.)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>

    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 30%">
          <strong>Buluşa ilişkin ayrıntılı teknik açıklama:</strong>
          <p>
            <em>
              (Buluşa ilişkin tüm teknik özelliklere ayrıntılı bir biçimde yer
              verilmelidir. Buluş bir ürün ise bu ürünün tüm parçalarından, bir
              yöntem ise yöntemin tüm basamaklarından bahsediniz. Buluşu
              oluşturan unsurların her birinin işlevini açıklayınız)
            </em>
          </p>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 30%">
          <strong
            >Buluşa ilişkin teknik alandaki rakip firmaların isimleri:
          </strong>
        </td>
        <td style="width: 70%">
          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 30%">
          <strong>Buluşa ilişkin görsel:</strong>

        </td>
        <td style="width: 85%">
          <div style="text-align: left">
            <div [innerHtml]="msg" *ngIf="msg" style="color: red"></div>
            <div>
              <img [src]="url" *ngIf="url" width="600" height="600" />
            </div>
            <p>
              <input type="file" (change)="selectFile($event)" />
            </p>
          </div>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 30%">
          <strong
            >Buluşun daha önce ifşa edilme durumu:
          </strong>
          <p>
          <em
            >EVET/HAYIR(EVET ise duruma ilişkin detayları
            belirtiniz.)</em
          ></p>
        </td>
        <td style="width: 70%">

          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table style="margin-left: 0%; box-sizing: border-box">
      <tr>
        <td style="width: 30%">
          <strong
            >Buluşun sözlü-yazılı yayını, tanıtımı ya da satışı gerçekleşti mi?
          </strong>
          <p>
          <em
            >EVET/HAYIR(EVET ise nerede ve ne zaman gerçekleştiğini
            açıklayınız)</em
          ></p>
        </td>
        <td style="width: 70%">

          <textarea rows="4" cols="70"> </textarea>
        </td>
      </tr>
    </table>
    <p></p>
</div>
<button
*ngIf="visibleBulusBildirimFormu"
ngxPrint
printSectionId="bbf"
class="btn"
(click)="onToggle()"
style="
  margin-left: auto;
  margin-right: 10%;
  font-size: 18px;
  display: block;
  background-color: #0275d8;
"
>
    PDF çıktısı al
  </button>
</div>
</div>

<table *ngIf="visibleTimeLimits" style="margin-left: 21%">
  <thead>
    <th>No.</th>
    <th>Durum</th>
    <th>Alınan Aksiyonun Tarihi</th>
    <th>Kayıtı oluşturan kişi</th>
    <th>Alınan Aksiyon Üzerinden Geçen Süre</th>

  </thead>
  <tbody>
    <tr *ngFor="let item of statusList; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ item.status }}</td>
      <td>{{ item.date | date: "dd/MM/yyyy" }}</td>
      <td>{{ item.recordigUser }}</td>
      <td>{{ item.date | DayAgo }}</td>

    </tr>
  </tbody>
</table>

<div *ngIf="visibleDecision" id="data">
  <ng-container *ngIf="visibleDecision && !toggle">
    <h3 style="color: #d70040">Buluş Durumunu Güncelle:</h3>
    <div class="form-check">
      <input
        [(ngModel)]="value"
        class="form-check-input"
        type="radio"
        value="{{ value + 1 }}"
      />
      <h6 class="form-check-label">Buluş Bildirimi İptal Edildi</h6>
    </div>
    <div class="form-check">
      <input
        [(ngModel)]="value"
        class="form-check-input"
        type="radio"
        value="{{ value + 2 }}"
      />
      <h6 class="form-check-label">
        Buluşun Tüm Hakları BULUŞ SAHİPLERİNE Bırakıldı
      </h6>
    </div>
    <div class="form-check">
      <input
        [(ngModel)]="value"
        class="form-check-input"
        type="radio"
        value="{{ value + 3 }}"
      />
      <h6 class="form-check-label">Buluşun GİZLİ tutulmasına karar verildi.</h6>
    </div>
    <div class="form-check">
      <input
        [(ngModel)]="value"
        class="form-check-input"
        type="radio"
        value="{{ value + 4 }}"
      />
      <h6 class="form-check-label">Buluşun tüm hakları ŞİRKETE BIRAKILDI</h6>
    </div>
    <button
      [disabled]="!value"
      class="btn"
      (click)="updateStatus()"
      style="
        margin-left: auto;
        margin-right: 20%;
        font-size: 18px;
        display: block;
        background-color: #0275d8;
      "
    >
      Durumu Güncelle
    </button>
  </ng-container>

  <h2 class="alert alert-danger">
    {{ errorText1 }}
  </h2>
  <span *ngIf="isStatusUpdated">
    <button class="btn" (click)="navigate()">Üst Menüye Git</button>
  </span>
</div>

<!-- <button
      [disabled]="!value"
      class="btn btn-success"
      (click)="updateStatusSendEmail()"
    >
      Durumu Güncelle ve Buluş Sahiplerine bilgi e-postası at.
    </button> -->

<table
  *ngIf="visibleDocuments && !foldertoggle && !valid"
  style="margin-left: 21%"
>
  <thead>
    <th>No.</th>
    <th>Dosyanın Türü</th>
    <th>Dosya Adı</th>
    <th>Dosyanın Yüklenme Tarihi</th>
    <th>Yüklenme Tarihi Üzerinden Geçen Süre</th>
    <th>Dosya İndir</th>
  </thead>
  <tbody>
    <tr *ngFor="let item of docLink; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ item.type }}</td>

      <td>{{ item.docName }}</td>
      <td>{{ item.date | date: "dd/MM/yyyy" }}</td>
      <td>{{ item.date | DayAgo }}</td>

      <td>
        <a class="nav-item nav-link" href="{{ item.link }}" target="_blank">
          Detaylar
        </a>
      </td>
      <td style="background-color: #f8f9fb">
        <button type="button" class="btn" (click)="deleteFolder(i)">
          Dosyayı Sil
        </button>
      </td>
    </tr>
  </tbody>
</table>

<div id="dataButton" *ngIf="visibleDocuments">
  <br />

  <button
    *ngIf="!foldertoggle && !valid"
    for="file"
    (click)="onFolderToggle()"
    type="button"
    class="btn"
    style="font-size: 18px"
  >
    Yeni Dosya Yükle
  </button>
  <h1 style="color: #28384f">{{ errorText }}</h1>
  <span *ngIf="valid">
    <button class="btn" (click)="navigate()">Üst Menüye Git</button>
  </span>
  <button
    class="btn btn-success"
    *ngIf="foldertoggle && !valid"
    (click)="onFolderToggle()"
  >
    Dosyalara geri dön
  </button>
  <hr />
  <ng-container *ngIf="foldertoggle && !valid">
    <h1 for="file">Yeni Dosya Yükleme</h1>
    <h3 for="file" style="color: #d70040">Dosya Türünü Seçiniz</h3>
    <p></p>
    <div>
      <div class="form-check">
        <input
          [(ngModel)]="fileName"
          class="form-check-input"
          type="radio"
          value="Buluş Bildirim Formu"
          name="Dosya adı"
        />
        <div class="form-check-label">Buluş Bildirim Formu</div>
      </div>
      <div class="form-check">
        <input
          [(ngModel)]="fileName"
          class="form-check-input"
          type="radio"
          value="Buluş Hak Talebi Karar Formu"
          name="Dosya adı"
        />
        <div class="form-check-label">Buluş Hak Talebi Karar Formu</div>
      </div>
      <div class="form-check">
        <input
          [(ngModel)]="fileName"
          class="form-check-input"
          type="radio"
          value="Buluş Sahibi sözleşmesi"
          name="Dosya adı"
        />
        <div class="form-check-label">Buluş Sahibi sözleşmesi</div>
      </div>
      <div class="form-check">
        <input
          [(ngModel)]="fileName"
          class="form-check-input"
          type="radio"
          value="Ülke Çıkışı Karar Formu"
          name="Dosya adı"
        />
        <div class="form-check-label">Ülke Çıkışı Karar Formu</div>
      </div>
      <!-- <button class="btn btn-warning" (click)="formName()">
          Dosya Adını Kendim Belirleyeceğim
        </button>
        <ng-container *ngIf="otherForm">
          <h3 for="file">İstediğiniz Dosya Adını Yazınız.</h3>
          <input type="text" [(ngModel)]="fileName" />
        </ng-container> -->
    </div>
    <br />
    <div>
      <h3 style="color: #d70040">Gelen/Gönderilen dosya</h3>
      <p></p>
      <div class="form-check">
        <input
          type="radio"
          class="form-check-input"
          value="Gelen Dosya"
          name="Gönderi"
          [(ngModel)]="myRadio"
        />

        <div class="form-check-label">Gelen Dosya</div>
      </div>
      <p></p>
      <div class="form-check">
        <input
          type="radio"
          class="form-check-input"
          value="Giden Dosya"
          name="Gönderi"
          [(ngModel)]="myRadio"
        />
        <div class="form-check-label">Gönderilen Dosya</div>
      </div>
    </div>
    <p></p>

    <input type="file" (change)="upload($event)" accept="*.pdf" /><br />

    <button
      [disabled]="myRadio === '' || fileName === '' || !isFolderLoaded"
      class="btn"
      (click)="uplodFolder()"
      style="
        background-color: #28384f;
        font-size: 18px;
        display: block;
        margin-left: auto;
        margin-right: 20%;
      "
    >
      Dosyayı Yükle
    </button>
  </ng-container>
</div>

<!--Recorded Patents -->
<div *ngIf="visiblePatents">
  <table style="margin-left: 21%">
    <thead>
      <th>No.</th>

      <th>Buluş Türü</th>
      <th>İlgili Ülke</th>
      <th>Bağlı Olduğu Buluş</th>
      <th>Giriş Tarihi</th>
      <th>Buluş Başlığı</th>
      <!-- <th>Buluş Özeti</th> -->

      <th>Yüklenme Tarihi</th>
      <th>Son Durum</th>
      <th>Notlar</th>
    </thead>
    <tbody>
      <tr *ngFor="let item of patentInfo; let i = index">
        <td
          [style.color]="
            item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
          "
        >
          {{ i + 1 }}
        </td>
        <td
          [style.color]="
            item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
          "
        >
          {{ item.patentType }}
        </td>

        <td
          [style.color]="
            item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
          "
        >
          {{ item.patentCountry }}
        </td>
        <td
          [style.color]="
            item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
          "
        >
          <ng-container *ngIf="item.hasOwnProperty('priority')">
            {{ item.priority.country }}/
            {{ item.priority.number }}</ng-container
          >
        </td>
        <td
          [style.color]="
            item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
          "
        >
          {{ item.patentDate | date: "dd/MM/yyyy" }}
        </td>
        <td
          [style.color]="
            item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
          "
        >
          {{ item.patentName }}
        </td>
        <!-- <td>{{ item.abstract }}</td> -->

        <td
          [style.color]="
            item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
          "
        >
          {{ item.patentStatus[0].date | date: "dd/MM/yyyy" }}
        </td>
        <td
          [style.color]="
            item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
          "
        > {{item.patentStatus.slice(-1)[0].status}} / {{item.patentStatus.slice(-1)[0].date | date:  "dd/MM/yyyy"}}
          <!-- {{
         item.patentStatus.slice(-1)[0].status[0] +
                "-" +
                (item.patentStatus.slice(-1)[0].status[1] | date: "dd/MM/yyyy")
          }} -->
        </td>
        <td
        [style.color]="
          item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
        "
      >
        {{
       item.countryNote
        }}
      </td>

        <!-- <td>{{ item.date | date: "dd/MM/yyyy" }}</td>
        <td>{{ item.date | DayAgo }}</td>
        <td>
          <a class="nav-item nav-link" href="{{ item.link }}" target="_blank">
            Detaylar
          </a>
        </td>-->
        <td>
          <button class="btn" (click)="enterCountry(i)" style="width: 80%">
            Ülkesel Girişi Görüntüle
          </button>
          <button
            id="green"
            class="btn"
            (click)="deletePatent(i)"
            style="width: 80%"
          >
            Ülkesel Girişi Sil
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <button class="btn btn-primary" (click)="recordPatent()" id="PatentKaydıEkle">
    Patent Kaydı Ekle
  </button>
</div>
<div *ngIf="visibleInventorButton">
  <span *ngFor="let inventor of inventorData; let i = index">
    <button
      class="btn btn-primary"
      [style.background-color]="i % 2 == 0 ? '#28384f' : '#d70040'"
      id="bulus-soz"
      *ngIf="!visibleInventorAgreement"
      (click)="createAgreement(i)"
      style="
        margin-left: 21%;
        margin-right: auto;
        font-size: 18px;
        display: block;
      "
    >
      {{ inventor.name }} için Buluş Sahibi sözlemesi
    </button>
    <p></p>
  </span>
</div>

<button
  *ngIf="visibleInventorAgreement"
  style="margin-left: 21%; margin-right: auto; font-size: 18px; display: block"
  ngxPrint
  printSectionId="contentToConvert"
  class="btn"
>
  PDF çıktısı al
</button>

<div *ngIf="visibleInventorAgreement" class="container" id="texthider">
  <!-- <div *ngIf="visibleInventorAgreement" class="container"></div> -->
  <div *ngIf="visibleInventorAgreement" id="contentToConvert" #contentToConvert>
    <!-- <div *ngIf="visibleInventorAgreement" id="data"> -->
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        margin-right: 2.45pt;
        text-align: center;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >HİZMET BULUŞU İLE İLGİLİ HAK GE&Ccedil;İŞ S&Ouml;ZLEŞMESİ</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        margin-right: 2.45pt;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        margin-right: 2.45pt;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >TARAFLAR</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 1-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;Ticari yerleşim yeri
        <strong>{{ IAFinventorsCompanyAdress }}&nbsp;</strong>adresi olan
        <strong>{{ IAFinventorsCompanyName }} </strong>(bu s&ouml;zleşmede
        İŞVEREN olarak anılacaktır.) ile
        <strong>{{ IAFinventorAdress }}&nbsp;</strong>adresi olan
        <strong>{{ IAFinventorName }}&nbsp;</strong>(bu s&ouml;zleşmede
        &Ccedil;ALIŞAN olarak anılacaktır) arasında aşağıdaki h&uuml;k&uuml;m ve
        koşullarla bir &ldquo;Hizmet Buluşu ile İlgili Hak Ge&ccedil;iş
        S&ouml;zleşmesi&rdquo; bağıtlanmıştır.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        margin-right: 2.45pt;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        margin-right: 2.45pt;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >KONU</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        margin-right: 2.45pt;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 2-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İŞVEREN&rsquo;in hizmetinde olan ve bu hizmet ilişkisini
        İŞVEREN&rsquo;in g&ouml;sterdiği belli bir işle ilgili olarak kişisel
        bir bağımlılık i&ccedil;inde ona karşı yerine getirmekle
        y&uuml;k&uuml;ml&uuml; olan &Ccedil;ALIŞAN&rsquo;ın
        ger&ccedil;ekleştirdiği buluş &lsquo;&lsquo;<strong
          >{{ inventionName }}&rsquo;&rsquo;</strong
        >
        konu başlığına Sahib; ve Resmi Kurum nezdinde
        <strong
          >{{ IAFinventorsPatentCountry }}/{{
            IAFinventorsPatentNumber
          }}</strong
        >
        numarasını alan patent başvurusuna ilişkindir.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >NİTELİĞİ</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 3-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İşbu s&ouml;zleşme konusu buluş, &Ccedil;ALIŞAN&rsquo;ın,
        işletmede y&uuml;k&uuml;ml&uuml; olduğu faaliyeti gereği
        ger&ccedil;ekleştirdiği veya işyerinin faaliyet g&ouml;sterdiği alanlar
        i&ccedil;inde, b&uuml;y&uuml;k &ouml;l&ccedil;&uuml;de işletmenin
        deneyim ve &ccedil;alışmalarına dayanarak iş ilişkisi sırasında yaptığı
        bir hizmet buluşudur. &Ccedil;ALIŞAN, buluşu işletmede verilen
        g&ouml;revlendirmenin doğrudan neden olduğu ve buluşun
        ger&ccedil;ekleştirilmesine işletmenin tam katkısının olduğu durumda
        geliştirmiştir ve buna g&ouml;re y&ouml;netmeliğin 20. Maddesinde
        belirtilen 3. Grupta yer almaktadır.&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&Ccedil;ALIŞAN BİLDİRİMİ</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 4-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;&Ccedil;ALIŞAN; teknik problemi,
        &ccedil;&ouml;z&uuml;m&uuml;n&uuml; ve buluşu nasıl
        ger&ccedil;ekleştirmiş olduğu hususundaki a&ccedil;ıklamasını yazılı
        olarak {{ inventionDate | date: "dd/MM/yyyy" }} tarihinde
        İŞVEREN&rsquo;e bildirmiştir.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >İŞVEREN BİLDİRİMİ</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 5-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İŞVEREN kendisine ulaşan bildirimin tebell&uuml;ğ tarihinin
        {{ IAFinventionDateOneMonthFormatted | date: "dd/MM/yyyy" }}
        olduğunu, bildirimde bulunan &Ccedil;ALIŞAN&rsquo;a
        {{ IAFinventionDateOneDayFormatted | date: "dd/MM/yyyy" }}
        g&uuml;n&uuml;nde yazılı şekilde bildirmiştir.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >HAK TALEBİ</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 6-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İŞVEREN, hizmet buluşu ile ilgili olarak tam hak talep ettiğini
        &Ccedil;ALIŞAN&rsquo;a
        {{ IAFinventionDateOneDayFormatted | date: "dd/MM/yyyy" }} tarihinde
        bildirmiştir.</span
      >
    </p>

    <p
      style="
        margin-right: 0cm;
        margin-left: 0cm;
        font-size: 18px;
        font-family: 'Calibri', sans-serif;
        margin-top: 0cm;
        margin-bottom: 0.0001pt;
        line-height: 18pt;
        margin: 0cm;
        text-align: justify;
      "
    >
      <strong
        ><span style="font-size: 18px; font-family: 'Arial', sans-serif"
          >İŞVERENİN BAŞVURU Y&Uuml;K&Uuml;M&Uuml;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 100%;
      "
    >
      <strong
        ><span style="font-size: 18px; font-family: 'Arial', sans-serif"
          >Madde 7-</span
        ></strong
      ><span style="font-size: 18px; font-family: 'Arial', sans-serif"
        >&nbsp;İŞVEREN hizmet buluşu i&ccedil;in patent (veya faydalı model)
        belgesi verilmesi amacıyla T&uuml;rk Patent ve Marka Kurumu (TPMK),
        D&uuml;nya Fikri M&uuml;lkiyet &Ouml;rg&uuml;t&uuml; (WIPO) ve/veya
        diğer uluslararası b&uuml;rolar (ofisler), Avrupa Patent Ofisi (EPO)
        ve/veya diğer b&ouml;lgesel ofisler, ABD Patent Ofisi (USPTO) ve/veya
        diğer yabancı &uuml;lke patent ofisleri ile b&uuml;rolarına başvuruda
        bulunma, &nbsp;yapmış olduğu başvuruyu geri &ccedil;ekme, feragat etme
        ve bunlarla sınırlı olmamak &uuml;zere gerekli olan her t&uuml;rl&uuml;
        işlemi yapma hak ve yetkisine haizdir.</span
      >
    </p>

    <p>
      <strong
        ><span style="font-size: 18px; font-family: 'Arial', sans-serif"
          >R&Uuml;&Ccedil;HANA DAYALI BAŞVURULARDA BİLDİRİM&nbsp;</span
        ></strong
      >
    </p>

    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 100%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 100%;
          font-family: 'Arial', sans-serif;
        "
        ><strong>Madde 8 &ndash;</strong> İŞVEREN patent almak istemediği
        yabancı &uuml;lkeler ile ilgili bildirimi ancak &Ccedil;ALIŞAN&rsquo;ın
        talebi &uuml;zerine yapabilir.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        line-height: 100%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 100%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        line-height: 100%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&Ccedil;ALIŞANIN RIZASI</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 9-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;&Ccedil;ALIŞAN, hizmet buluşu i&ccedil;in İŞVEREN&lsquo;in
        başvuru yapmasına veya yapmamasına rıza g&ouml;stermektedir.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >SIR TUTMA Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;Ğ&Uuml;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 10-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;&Ccedil;ALIŞAN, hizmet buluşunu serbest buluş niteliğini
        kazanmadığı s&uuml;rece gizli tutmakla y&uuml;k&uuml;ml&uuml;d&uuml;r.
        İŞVEREN tam hak talep etmiş olduğu durumda, hizmet buluşunu herhangi bir
        yolla ifşa edebilir.&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >TARAFLARIN HAK VE Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;KLERİ</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 11-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İŞVEREN, hizmet buluşuna patent (veya faydalı model) verilmesi
        i&ccedil;in yaptığı başvuru ve eklerinin suretlerini
        &Ccedil;ALIŞAN&rsquo;a sunmuştur ve &Ccedil;ALIŞAN&rsquo;ın talebi
        &uuml;zerine başvuru işlemleri sırasındaki gelişmeleri
        &Ccedil;ALIŞAN&rsquo;a bildirmekle y&uuml;k&uuml;ml&uuml;d&uuml;r.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&Ccedil;ALIŞAN, patent (veya faydalı model) belgesi alınabilmesi
        i&ccedil;in gerekli bilgileri işverene bildirmek ve gerekli yardımı
        yapmakla y&uuml;k&uuml;ml&uuml;d&uuml;r.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&Ouml;DEVLER</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 12-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İŞVEREN, &Ccedil;ALIŞAN&rsquo;ın hizmet buluşu nedeniyle patent
        (veya faydalı model) belgesi verilmesi i&ccedil;in yaptığı başvuruyu
        takip etmek istemez veya patent (ya da faydalı model) belgesi hakkının
        korunmasında vazge&ccedil;mek isterse, durumu &Ccedil;ALIŞAN&rsquo;a
        bildirmekle y&uuml;k&uuml;ml&uuml;d&uuml;r.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&Ccedil;ALIŞAN&rsquo;ın talebi &uuml;zerine İŞVEREN, masrafları
        &Ccedil;ALIŞAN&rsquo;a ait olmak &uuml;zere patent (veya faydalı model)
        belgesi hakkını veya bunlardan birinin alınması veya korunması
        i&ccedil;in gerekli olan belgeleri &Ccedil;ALIŞAN&rsquo;a devir etmek
        zorundadır. &Ccedil;ALIŞAN, bu konuda kendisine yapılan bildirime, bu
        bildirimin ulaşması tarihinden itibaren &uuml;&ccedil; ay i&ccedil;inde
        cevap vermezse, İŞVEREN s&ouml;z konusu başvuruyu veya patent (veya
        faydalı model) belgesinden doğan haklardan
        vazge&ccedil;ebilir.&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 13-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;&Ccedil;ALIŞAN, İŞVEREN&rsquo;in ge&ccedil;erli mevzuata uygun
        şekilde hazırladığı Fikri Haklar Y&ouml;netmeliği&rsquo;nde yer alan
        t&uuml;m hususları okuduğunu ve şartları kabul ettiğini beyan eder.
        &Ccedil;alışan, patent teşvik priminin yılda bir kez topluca
        &ouml;deneceğini kabul eder.&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >YEDEK KURALLAR</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 14-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İş bu s&ouml;zleşmede olmayan konularda T&uuml;rk Maddi Hukuk
        kuralları uygulanır.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >S&Ouml;ZLEŞME TEVDİİ</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 15-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İşbu hizmet buluşu ile ilgili hak ge&ccedil;iş s&ouml;zleşmesi
        iki asıl olarak d&uuml;zenlenip imza edildikten sonra, taraflara birer
        n&uuml;shası tevdi edilmiştir.&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Y&Uuml;R&Uuml;RL&Uuml;K</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >Madde 16-</span
        ></strong
      ><span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;İş bu s&ouml;zleşme onaltı maddeden ibaret olup,
        T&uuml;rk&ccedil;e dilinde
        {{ IAFinventionDateOneDayFormatted | date: "dd/MM/yyyy" }} tarihinde
        taraflarca imzalanarak y&uuml;r&uuml;rl&uuml;ğe girmiştir.</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        text-align: justify;
        line-height: 150%;
      "
    >
      <span
        style="
          font-size: 18px;
          line-height: 150%;
          font-family: 'Arial', sans-serif;
        "
        >&nbsp;</span
      >
    </p>
    <p
      style="
        margin: 0cm;
        margin-bottom: 0.0001pt;
        font-size: 18px;
        font-family: 'Times New Roman', serif;
        line-height: 150%;
      "
    >
      <strong
        ><span
          style="
            font-size: 18px;
            line-height: 150%;
            font-family: 'Arial', sans-serif;
          "
          >{{ IAFinventorsCompanyName }} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&Ccedil;ALIŞAN</span
        ></strong
      >
    </p>
  </div>
  <!-- </div> -->
</div>
